<template>
  <div>
    <Head title="會員中心 - 會員類型" />
    <user-template title="會員中心">
      <template #header>會員類型</template>

      <main>
        <div v-if="$page.props.auth.user.level == 1">
          <div class="flex justify-between my-10">
            <div>
              <span>目前類型</span>
              <span class="ml-5 font-bold">一般會員</span>
            </div>
            <div>
              <Link :href="route('members')">會員規則查看</Link>
            </div>
          </div>

          <template
            v-if="
              (!$page.props.auth.user.attributes?.degraded_at &&
                ($page.props.rules.regular?.cv?.checked ||
                  $page.props.rules.regular?.referral?.checked)) ||
              ($page.props.auth.user.attributes?.degraded_at &&
                ($page.props.rules.degraded?.cv?.checked ||
                  $page.props.rules.degraded?.referral?.checked))
            "
          >
            <div v-if="!$page.props.auth.user.attributes?.degraded_at">
              滿足以下其中 1 個條件即可通過審核成為推廣會員。
            </div>
            <div v-else>滿足以下其中 1 個條件即可恢復為推廣會員。</div>

            <template v-if="!$page.props.auth.user.attributes?.degraded_at">
              <div
                v-show="rule.checked"
                :key="key"
                v-for="(rule, key) in $page.props.rules.regular"
                class="border border-fh-gray-border my-4 py-4 px-2"
              >
                <template v-if="key == 'cv' && rule.checked">
                  <div class="mb-4" v-if="rule.period > 0">
                    {{ rule.period }} 個完整週期內的累計
                    {{ rule.referred ? "C.V.T." : "C.V." }} 達
                    {{ rule.amount | commaFormat }}。
                  </div>
                  <div class="mb-4" v-else>
                    自註冊日起累計 {{ rule.referred ? "C.V.T." : "C.V." }} 達
                    {{ rule.amount | commaFormat }}。
                  </div>

                  <div class="mb-4">
                    <ProgressBar
                      style="height: 6px"
                      :value="
                        calculateProgressBar(
                          $page.props.auth.user.attributes?.total_cv
                            ?.from_begin ?? 0,
                          $page.props.rules.regular.cv.amount
                        )
                      "
                      :showValue="false"
                    />
                  </div>

                  <div class="flex justify-between">
                    <div>
                      目前：{{
                        $page.props.auth.user.attributes?.total_cv
                          ?.from_begin ?? 0 | commaFormat
                      }}
                    </div>
                    <div
                      v-if="
                        ($page.props.rules.regular.cv.amount -
                          $page.props.auth.user.attributes?.total_cv
                            ?.from_begin ?? 0) > 0
                      "
                    >
                      還差
                      {{
                        $page.props.rules.regular.cv.amount -
                          $page.props.auth.user.attributes?.total_cv
                            ?.from_begin ?? 0 | commaFormat
                      }}
                    </div>
                    <div v-else>已達成</div>
                  </div>
                </template>

                <template v-if="key == 'referral' && rule.checked">
                  <div class="mb-4" v-if="rule.period > 0">
                    {{ rule.period }} 個完整週期內的累計推薦人數達
                    {{ rule.quantity }} 人。
                  </div>
                  <div class="mb-4" v-else>
                    自註冊日起累計推薦人數達
                    {{ rule.quantity }} 人。
                  </div>

                  <div class="mb-4">
                    <ProgressBar
                      style="height: 6px"
                      :value="
                        calculateProgressBar(
                          $page.props.auth.user.attributes?.referred_count
                            ?.from_begin ?? 0,
                          $page.props.rules.regular.referral.quantity
                        )
                      "
                      :showValue="false"
                    />
                  </div>

                  <div class="flex justify-between">
                    <div>
                      目前：{{
                        $page.props.auth.user.attributes?.referred_count
                          ?.from_begin ?? 0 | commaFormat
                      }}
                      人
                    </div>
                    <div
                      v-if="
                        ($page.props.rules.regular.referral.quantity -
                          $page.props.auth.user.attributes?.referred_count
                            ?.from_begin ?? 0) > 0
                      "
                    >
                      還差
                      {{
                        $page.props.rules.regular.referral.quantity -
                          $page.props.auth.user.attributes?.referred_count
                            ?.from_begin ?? 0 | commaFormat
                      }}
                      人
                    </div>
                    <div v-else>已達成</div>
                  </div>
                </template>
              </div>
            </template>
            <template v-else>
              <div
                v-show="rule.checked"
                :key="key"
                v-for="(rule, key) in $page.props.rules.degraded"
                class="border border-fh-gray-border my-4 py-4 px-2"
              >
                <template v-if="key == 'cv' && rule.checked">
                  <div class="mb-4" v-if="rule.period > 0">
                    {{ rule.period }} 個完整週期內的累計
                    {{ rule.referred ? "C.V.T." : "C.V." }} 達
                    {{ rule.amount | commaFormat }}。
                  </div>
                  <div class="mb-4" v-else>
                    自降級日起累計
                    {{ rule.referred ? "C.V.T." : "C.V." }} 達
                    {{ rule.amount | commaFormat }}。
                  </div>

                  <div class="mb-4">
                    <ProgressBar
                      style="height: 6px"
                      :value="
                        calculateProgressBar(
                          $page.props.auth.user.attributes?.total_cv
                            ?.after_degradation ?? 0,
                          $page.props.rules.degraded.cv.amount
                        )
                      "
                      :showValue="false"
                    />
                  </div>

                  <div class="flex justify-between">
                    <div>
                      目前：{{
                        $page.props.auth.user.attributes?.total_cv
                          ?.after_degradation ?? 0 | commaFormat
                      }}
                    </div>
                    <div
                      v-if="
                        ($page.props.rules.degraded.cv.amount -
                          $page.props.auth.user.attributes?.total_cv
                            ?.after_degradation ?? 0) > 0
                      "
                    >
                      還差
                      {{
                        $page.props.rules.degraded.cv.amount -
                          $page.props.auth.user.attributes?.total_cv
                            ?.after_degradation ?? 0 | commaFormat
                      }}
                    </div>
                    <div v-else>已達成</div>
                  </div>
                </template>

                <template v-if="key == 'referral' && rule.checked">
                  <div class="mb-4" v-if="rule.period > 0">
                    {{ rule.period }} 個完整週期內的累計推薦人數達
                    {{ rule.quantity }} 人。
                  </div>
                  <div class="mb-4" v-else>
                    自降級日起累計推薦人數達
                    {{ rule.quantity }} 人。
                  </div>

                  <div class="mb-4">
                    <ProgressBar
                      style="height: 6px"
                      :value="
                        calculateProgressBar(
                          $page.props.auth.user.attributes?.referred_count
                            ?.after_degradation ?? 0,
                          $page.props.rules.degraded.referral.quantity
                        )
                      "
                      :showValue="false"
                    />
                  </div>

                  <div class="flex justify-between">
                    <div>
                      目前：{{
                        $page.props.auth.user.attributes?.referred_count
                          ?.after_degradation ?? 0 | commaFormat
                      }}
                      人
                    </div>
                    <div
                      v-if="
                        ($page.props.rules.degraded.referral.quantity -
                          $page.props.auth.user.attributes?.referred_count
                            ?.after_degradation ?? 0) > 0
                      "
                    >
                      還差
                      {{
                        $page.props.rules.degraded.referral.quantity -
                          $page.props.auth.user.attributes?.referred_count
                            ?.after_degradation ?? 0 | commaFormat
                      }}
                      人
                    </div>
                    <div v-else>已達成</div>
                  </div>
                </template>
              </div>
            </template>
          </template>
        </div>
        <div v-if="$page.props.auth.user.level == 2">
          <div class="flex justify-between my-10">
            <div>
              <span>目前類型</span>
              <span class="ml-5 font-bold">推廣會員</span>
            </div>
            <div>
              <Link as="Button" :href="route('members')">會員規則查看</Link>
            </div>
          </div>

          <template
            v-if="
              $page.props.rules.upgraded?.cv?.checked ||
              $page.props.rules.upgraded?.referral?.checked
            "
          >
            <div>滿足以下其中 1 個條件即可維持推廣會員資格。</div>

            <div
              v-show="rule.checked"
              :key="key"
              v-for="(rule, key) in $page.props.rules.upgraded"
              class="border border-fh-gray-border my-4 py-4 px-2"
            >
              <template v-if="key == 'cv' && rule.checked">
                <div class="mb-4" v-if="rule.period > 0">
                  {{ rule.period }} 個完整週期內的累計
                  {{ rule.referred ? "C.V.T." : "C.V." }} 達
                  {{ rule.amount | commaFormat }}。
                </div>
                <div class="mb-4" v-else>
                  自升級日起累計
                  {{ rule.referred ? "C.V.T." : "C.V." }} 達
                  {{ rule.amount | commaFormat }}。
                </div>

                <div class="mb-4">
                  <ProgressBar
                    style="height: 6px"
                    :value="
                      calculateProgressBar(
                        $page.props.auth.user.attributes?.total_cv
                          ?.after_upgradation ?? 0,
                        $page.props.rules.upgraded.cv.amount
                      )
                    "
                    :showValue="false"
                  />
                </div>

                <div class="flex justify-between">
                  <div>
                    目前：{{
                      $page.props.auth.user.attributes?.total_cv
                        ?.after_upgradation ?? 0 | commaFormat
                    }}
                  </div>
                  <div
                    v-if="
                      ($page.props.rules.upgraded.cv.amount -
                        $page.props.auth.user.attributes?.total_cv
                          ?.after_upgradation ?? 0) > 0
                    "
                  >
                    還差
                    {{
                      $page.props.rules.upgraded.cv.amount -
                        $page.props.auth.user.attributes?.total_cv
                          ?.after_upgradation ?? 0 | commaFormat
                    }}
                  </div>
                  <div v-else>已達成</div>
                </div>
              </template>

              <template v-if="key == 'referral' && rule.checked">
                <div class="mb-4" v-if="rule.period > 0">
                  {{ rule.period }} 個完整週期內的累計推薦人數達
                  {{ rule.quantity }} 人。
                </div>
                <div class="mb-4" v-else>
                  自升級日起累計推薦人數達
                  {{ rule.quantity }} 人。
                </div>

                <div class="mb-4">
                  <ProgressBar
                    style="height: 6px"
                    :value="
                      calculateProgressBar(
                        $page.props.auth.user.attributes?.referred_count
                          ?.after_upgradation ?? 0,
                        $page.props.rules.upgraded.referral.quantity
                      )
                    "
                    :showValue="false"
                  />
                </div>

                <div class="flex justify-between">
                  <div>
                    目前：{{
                      $page.props.auth.user.attributes?.referred_count
                        ?.after_upgradation ?? 0 | commaFormat
                    }}
                    人
                  </div>
                  <div
                    v-if="
                      ($page.props.rules.upgraded.referral.quantity -
                        $page.props.auth.user.attributes?.referred_count
                          ?.after_upgradation ?? 0) > 0
                    "
                  >
                    還差
                    {{
                      $page.props.rules.upgraded.referral.quantity -
                        $page.props.auth.user.attributes?.referred_count
                          ?.after_upgradation ?? 0 | commaFormat
                    }}
                    人
                  </div>
                  <div v-else>已達成</div>
                </div>
              </template>
            </div>
          </template>
        </div>
        <div v-if="$page.props.auth.user.level == 3">管理員</div>
      </main>
    </user-template>
  </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import UserTemplate from "./Shared/UserTemplate";
import ProgressBar from "primevue/progressbar";
import Button from "primevue/button";

export default {
  components: {
    UserTemplate,
    ProgressBar,
    Button,
  },
  filters: {
    // priceFormat: function (value) {
    //   return "$" + value;
    // },
    commaFormat: function (value) {
      return value
        .toString()
        .replace(
          /^(-?\d+?)((?:\d{3})+)(?=\.\d+$|$)/,
          function (all, pre, groupOf3Digital) {
            return pre + groupOf3Digital.replace(/\d{3}/g, ",$&");
          }
        );
    },
  },
  layout: Layout,
  data() {
    return {
      //
    };
  },
  methods: {
    calculateProgressBar(current, target) {
      let percentage = Math.round((current / target) * 10000) / 100;
      if (percentage > 100) percentage = 100;
      return percentage;
    },
  },
};
</script>

<style lang="postcss">
/*  */
</style>